module.exports = __webpack_public_path__ + "img/specialty.bb40a002.jpg";